import React from 'react';
import { ArrowLeftRight, X } from 'lucide-react';
import { getTechniquesCoveredBy } from '../../lib/selectors';
import MappedEntities from './MappedEntities';

// Defence detail card (prototype .detail). Shows the control + the ATT&CK
// techniques it mitigates (from the graph, with provenance).
const ControlDetails = ({ controlId, details, renderText, onClose, onCompare, alternateFrameworkLabel }) => {
  if (!controlId || !details) return null;

  const coveredTechniques = getTechniquesCoveredBy(controlId).map(({ technique, via }) => ({
    id: technique.id,
    name: technique.name,
    source: via.source,
    confidence: via.confidence,
  }));

  const renderEvent = (event, i) => {
    if (typeof event === 'string') {
      return (
        <span key={i} className="tv-chip risk">
          {renderText ? renderText(event) : event}
        </span>
      );
    }
    return (
      <a key={i} href={event.url} target="_blank" rel="noopener noreferrer" className="tv-chip risk">
        {renderText ? renderText(event.name) : event.name} ↗
      </a>
    );
  };

  return (
    <div className="tv-detail">
      <div className="tv-dh">
        <span className="tv-did" style={{ color: 'var(--tv-defence)' }}>{controlId}</span>
        <h3>{renderText ? renderText(details.name) : details.name}</h3>
        <span style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          {onCompare && (
            <button
              className="tv-btn"
              onClick={onCompare}
              title={`Compare with ${alternateFrameworkLabel}`}
            >
              <ArrowLeftRight style={{ width: 14, height: 14 }} /> Compare
            </button>
          )}
          {onClose && (
            <button className="tv-close" onClick={onClose} aria-label="Close details">
              <X style={{ width: 18, height: 18 }} />
            </button>
          )}
        </span>
      </div>
      <div className="tv-dtac">{details.family || 'Control'} · Defence</div>
      <p className="tv-desc">{renderText ? renderText(details.description) : details.description}</p>

      {details.threat_events && details.threat_events.length > 0 && (
        <div className="tv-sec">
          <div className="tv-st">Associated threat events</div>
          <div className="tv-chips">{details.threat_events.map(renderEvent)}</div>
        </div>
      )}

      {details.supplemental_guidance && (
        <div className="tv-sec">
          <div className="tv-st">Supplemental guidance</div>
          <p className="tv-desc" style={{ margin: 0 }}>
            {renderText ? renderText(details.supplemental_guidance) : details.supplemental_guidance}
          </p>
        </div>
      )}

      {details.implementation_guidance && (
        <div className="tv-sec">
          <div className="tv-st">Implementation guidance</div>
          <p className="tv-desc" style={{ margin: 0 }}>
            {renderText ? renderText(details.implementation_guidance) : details.implementation_guidance}
          </p>
        </div>
      )}

      {details.related_controls && (
        <div className="tv-sec">
          <div className="tv-st">Related controls</div>
          <div className="tv-chips">
            {details.related_controls.map((c, i) => (
              <span key={i} className="tv-chip">{c}</span>
            ))}
          </div>
        </div>
      )}

      {/* ATT&CK techniques this control mitigates (graph, provenance). */}
      <MappedEntities
        title="Techniques mitigated"
        items={coveredTechniques}
        chipClass="con"
        emptyHint="No mapped ATT&CK techniques in the loaded datasets for this control."
      />
    </div>
  );
};

export default ControlDetails;
